import React, { useEffect, useState, useRef } from "react";
import "./style.scss";
import MapIcon from "../../assets/images/map.svg";
import DateIcon from "../../assets/images/date.svg";
import CentreIcon from "../../assets/images/centre.svg";
import { useStores } from "../../stores";
import moment from "moment";
import { useLocation, useNavigate } from "react-router-dom";

function FilterList({ onFilterDataChange, onFilterCityData }) {
  const { bookingStore } = useStores();
  const [cityList, setCityList] = useState([]);
  const [centerListLoaded, setCenterListLoaded] = useState(false);

  const [selectedCity, setSelectedCity] = useState("");
  const [centerList, setCenterList] = useState([]);
  const [selectedCenter, setSelectedCenter] = useState("");
  const [loader, setLoader] = useState(true);
  const dateRef = useRef();
  const today = new Date();
  const date = moment(today).format("YYYY-MM-DD");
  const location = useLocation();
  const navigate = useNavigate();
  const [hasReload, setHasReload] = useState(false);
  const [hasHandleClick, setHasHandleClick] = useState(false);


  const [selectedDate, setSelectedDate] = useState(date); // Use state for selectedDate
  const formattedDate = moment(today).format('ddd, D MMM, YYYY');
  const [selectedDateFormat, setSelectedDateFormat] = useState(selectedDate);

  const getCenterListCalled = useRef(false);
  const getCityListCalled = useRef(false);

  useEffect(() => {
    setSelectedDateFormat(formattedDate); 
  }, []);

  const getCityList = async (city) => {
    if (getCityListCalled.current) {
      return;
    }
    getCityListCalled.current = true;
    await bookingStore.getCityListDayPass((response) => {
      if (response?.data?.status === 1) {
        setSelectedCity(city);
        setCityList(response?.data.data);
        onFilterCityData(response?.data?.data);
        if (!selectedCity && response?.data?.data.length > 0 && !city) {
          setSelectedCity(response?.data?.data[0].id);
        }
      } else {
        console.error("Error fetching city list");
      }
      setLoader(false);
    });
  };

  const getCenterList = async (cityId, newDate, newCenter, triggerChange) => {
    console.log("newCenter:>>>>>>>", newCenter);
    if (getCenterListCalled.current) {
      return;
    }
    getCenterListCalled.current = true;
    await bookingStore.getCenterListDayPass(cityId, (response) => {
      if (response?.data?.status === 1) {
        if(triggerChange != 'onChangeTrigger' && triggerChange != 'handleDateTrigger' ){
         setCenterList(response?.data?.data);
        }
        onFilterDataChange(response?.data?.data);
        if(hasReload){
        updateQueryParams(selectedCity, newDate || selectedDate, newCenter || selectedCenter);
        }
        setHasReload(true)

         setCenterListLoaded(true);
      } else {
        setCenterList([{ id: "no-data", name: "Sorry No Data Found" }]);
        onFilterDataChange([]);
        console.error("Error fetching center list");
      }
      setLoader(false);
    });
  };

  useEffect(() => {
    // Fetch center list

    if (selectedCity) {
      let params = `city_id=${selectedCity}&start_time=${selectedDate}`;
      getCenterList(params);
    }
  }, [selectedCity, selectedDate]);
  
  useEffect(() => {
    // Initialize query parameters from the URL
    const urlParams = new URLSearchParams(location.search);
    const cityIdFromParams = urlParams.get("city_id");
    const centerIdFromParams = parseInt(urlParams.get("center_id"), 10);
    setSelectedCenter(centerIdFromParams);

    if (cityIdFromParams && cityList) {
      getCityList(cityIdFromParams);
      const city = cityList.find((item) => item.id === cityIdFromParams);
      if (city) {
        setSelectedCity(city.name);
      }
    } else {
      getCityList(null);
    }  
      
    const startTimeFromParams = urlParams.get("start_time");
    if (startTimeFromParams && !hasHandleClick) {
      setSelectedDate(startTimeFromParams);
    }
  }, [location, cityList, centerListLoaded]);
  

  

  const handleDateChange = (e) => {
    console.log("e ", e.target.value);
    setHasHandleClick(true);
    const newDate = e.target.value;
    setSelectedDate(newDate); 

    const formattedDate = moment(newDate).format('ddd, D MMM, YYYY');

    setSelectedDateFormat(formattedDate);

    if (selectedCity) {
      let params = `city_id=${selectedCity}&start_time=${newDate}`;
      
      if (selectedCenter) {
        params += `&center_id=${selectedCenter}`;
      }
      
      getCenterListCalled.current = false;
      getCenterList(params, newDate, null, 'handleDateTrigger');
      // updateQueryParams(selectedCity, newDate, selectedCenter);
    }
  };

  const updateQueryParams = (cityId, startDate, center) => {
    const queryParams = new URLSearchParams();
    if (cityId) {
      queryParams.set("city_id", cityId);
    }
    if (startDate) {
      queryParams.set("start_time", startDate);
    }
    if (center) {
      queryParams.set("center_id", center);
    }

  const queryParamsTwo = new URLSearchParams(window.location.search);
  const utm_source = queryParamsTwo.get("utm_source");
  const utm_medium = queryParamsTwo.get("utm_medium");
  const utm_campaign = queryParamsTwo.get("utm_campaign");

  if (utm_source) {
    queryParams.set("utm_source", utm_source);
  }
  if (utm_medium) {
    queryParams.set("utm_medium", utm_medium);
  }
  if (utm_campaign) {
    queryParams.set("utm_campaign", utm_campaign);
  }

    const queryString = queryParams.toString();
    const newPath = `${window.location.pathname}?${queryString}`;
    navigate(newPath, { replace: true });
  };

  return (
    <div className="filter-list-container col-md-12">
      <div className="form-group icon-group">
        <img src={MapIcon} alt="Location" className="map-icon" />
        <select
          className="form-control filter-field"
          id="citySelect"
          value={selectedCity}
          onChange={(e) => {
            e.preventDefault();
            setSelectedCity(e.target.value);
            setSelectedCenter('');
            getCenterListCalled.current = false;
           
          }}
        >
          {cityList.map((item) => (
            <option key={item.id} value={item.id}>
              {item.name}
            </option>
          ))}
        </select>
      </div>

      <div className="form-group icon-group">
        <img src={CentreIcon} alt="Center" className="map-icon" />
        <select
          className="form-control filter-field"
          id="centerSelect"
          value={selectedCenter} 
          onChange={(e) => {
            e.preventDefault();
            const selectedCenterId = e.target.value;
            setSelectedCenter(selectedCenterId);
            getCenterListCalled.current = false;
            console.log("selectedCenterId>>>>>", selectedCenterId);
            if (selectedCenterId) {
              getCenterList(`center_id=${selectedCenterId}`, selectedDate, selectedCenterId, 'onChangeTrigger');
            }
         }}
        >
          <option value=''>Select a Center</option>
          {centerList.map((item, index) => (
            <option key={index} value={item.id}>
              {item.name}
            </option>
          ))}
        </select>
      </div>


      <div class="form-group icon-group"   onClick={() => { dateRef.current.showPicker();}}>
        <img src={DateIcon} alt="Location" class="map-icon"/>
          
          <input ref={dateRef} class="form-control filterDateDayPass date"  id="date-filter" type="date"  min={date}  value={selectedDate}
            onChange={handleDateChange}/>
            <span class="open-button-filter">
            <img
              src={require("../../assets/images/down.png")}
              alt="Date"
              className="date-icon"
            />
              </span>
              <p class="date-home-day-pass">{selectedDateFormat}</p>
            </div>



    </div>
  );
}

export default FilterList;
